<div class="row" style="padding: 10px;">
  <div class="col-6">
    <div class="row">
      <div class="col-12">
        <app-form-group-input [label]="'insert-client-company.company-name' | translate" inputType="text" [placeHolder]="'insert-client-company.company-name' | translate" [(model)]="company.name"></app-form-group-input>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <app-form-group-input [label]="'insert-client-company.first-email' | translate" inputType="email" [placeHolder]="'insert-client-company.first-email' | translate" [(model)]="company.firstEmail"></app-form-group-input>
      </div>
      <div class="col-6">
        <app-form-group-input [label]="'insert-client-company.second-email' | translate" inputType="email" [placeHolder]="'insert-client-company.second-email' | translate" [(model)]="company.secondEmail"></app-form-group-input>
      </div>
      <div class="col-6">
        <app-form-group-input [label]="'insert-client-company.first-phone' | translate" inputType="text" [placeHolder]="'insert-client-company.first-phone' | translate" [(model)]="company.firstPhone"></app-form-group-input>
      </div>
      <div class="col-6">
        <app-form-group-input [label]="'insert-client-company.second-phone' | translate" inputType="text" [placeHolder]="'insert-client-company.second-phone' | translate" [(model)]="company.secondPhone"></app-form-group-input>
      </div>
    </div>
  </div>
  <div class="col-6">
    <div class="row">
      <div class="col-6">
        <app-form-group-input [label]="'insert-client-company.fiscal-code' | translate" inputType="text" [placeHolder]="'insert-client-company.fiscal-code' | translate" [(model)]="company.fiscalCode"></app-form-group-input>
      </div>
      <div class="col-6">
        <app-form-group-input [label]="'insert-client-company.vat' | translate" inputType="text" [placeHolder]="'insert-client-company.vat' | translate" [(model)]="company.vat"></app-form-group-input>
      </div>
      <div class="col-6">
        <app-form-group-input [label]="'insert-client-company.pec-email' | translate" inputType="text" [placeHolder]="'insert-client-company.pec-email' | translate" [(model)]="company.pecEmail"></app-form-group-input>
      </div>
      <div class="col-6">
        <app-form-group-input [label]="'insert-client-company.isd-number' | translate" inputType="text" [placeHolder]="'insert-client-company.isd-number' | translate" [(model)]="company.isdNumber"></app-form-group-input>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="row">
      <div class="col-6">
          <app-form-group-input [label]="'insert-client-company.address' | translate" inputType="text" [placeHolder]="'insert-client-company.address' | translate" [(model)]="company.address"></app-form-group-input>
      </div>
      <div class="col-3">
        <app-form-group-input [label]="'insert-client-company.postal-code' | translate" inputType="text" [placeHolder]="'insert-client-company.postal-code' | translate" [(model)]="company.postalCode"></app-form-group-input>
      </div>
      <div class="col-3">
        <app-form-group-input [label]="'insert-client-company.city' | translate" inputType="text" [placeHolder]="'insert-client-company.city' | translate" [(model)]="company.city"></app-form-group-input>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <app-form-group-input [label]="'insert-client-company.village' | translate" inputType="text" [placeHolder]="'insert-client-company.village' | translate" [(model)]="company.village"></app-form-group-input>
      </div>
      <div class="col">
        <app-form-group-input [label]="'insert-client-company.district' | translate" inputType="text" [placeHolder]="'insert-client-company.district' | translate" [(model)]="company.district"></app-form-group-input>
      </div>
      <div class="col">
        <app-select [label]="'insert-client-company.country' | translate" [options]="countrySelectOptions" [(model)]="countryId" (modelChange)="changeCountry()"></app-select>
      </div>
    </div>
  </div>
</div>